import { defineMessages, type MessageDescriptor } from 'react-intl-next';

export type EventTypeMessages = {
	absolute: MessageDescriptor;
	relative: MessageDescriptor;
	standalone: MessageDescriptor;
};

export const clickedEventTypeMessages: EventTypeMessages = defineMessages({
	absolute: {
		defaultMessage: '{collaborator} clicked on {absoluteTime}',
		description: 'action taken by the user on this object with absolute timestamp - clicked',
		id: 'recommended.eventTypeMessage.absolute.clicked',
	},
	relative: {
		defaultMessage: '{collaborator} clicked {relativeTime}',
		description: 'action taken by the user on this object with relative timestamp - clicked',
		id: 'recommended.eventTypeMessage.relative.clicked',
	},
	standalone: {
		defaultMessage: '{collaborator} clicked',
		description: 'action taken by the user on this object - clicked',
		id: 'recommended.eventTypeMessage.clicked',
	},
});

export const commentedEventTypeMessages: EventTypeMessages = defineMessages({
	absolute: {
		defaultMessage: '{collaborator} commented on {absoluteTime}',
		description: 'action taken on this object with absolute timestamp - comment added',
		id: 'recommended.eventTypeMessage.absolute.commented',
	},
	relative: {
		defaultMessage: '{collaborator} commented {relativeTime}',
		description: 'action taken by the user on this object with relative timestamp - comment added',
		id: 'recommended.eventTypeMessage.relative.commented',
	},
	standalone: {
		defaultMessage: '{collaborator} commented',
		description: 'action taken by the user on this object - comment added',
		id: 'recommended.eventTypeMessage.commented',
	},
});

export const editedEventTypeMessages: EventTypeMessages = defineMessages({
	absolute: {
		defaultMessage: '{collaborator} edited on {absoluteTime}',
		description: 'action taken by the user on this object with absolute timestamp - edited',
		id: 'recommended.eventTypeMessage.absolute.edited',
	},
	relative: {
		defaultMessage: '{collaborator} edited {relativeTime}',
		description: 'action taken by the user on this object with relative timestamp - edited',
		id: 'recommended.eventTypeMessage.relative.edited',
	},
	standalone: {
		defaultMessage: '{collaborator} edited',
		description: 'action taken by the user on this object - edited',
		id: 'recommended.eventTypeMessage.edited',
	},
});

export const viewedEventTypeMessages: EventTypeMessages = defineMessages({
	absolute: {
		defaultMessage: '{collaborator} viewed on {absoluteTime}',
		description: 'action taken by the user on this object with absolute timestamp - viewed',
		id: 'recommended.eventTypeMessage.absolute.viewed',
	},
	relative: {
		defaultMessage: '{collaborator} viewed {relativeTime}',
		description: 'action taken by the user on this object with relative timestamp - viewed',
		id: 'recommended.eventTypeMessage.relative.viewed',
	},
	standalone: {
		defaultMessage: '{collaborator} viewed',
		description: 'action taken by the user on this object - viewed',
		id: 'recommended.eventTypeMessage.viewed',
	},
});

export const wereMentionedEventTypeMessages: EventTypeMessages = defineMessages({
	absolute: {
		defaultMessage: '{collaborator} were mentioned on {absoluteTime}',
		description: 'action taken by the user on this object with absolute timestamp - were mentioned',
		id: 'recommended.eventTypeMessage.absolute.wereMentioned',
	},
	relative: {
		defaultMessage: '{collaborator} were mentioned {relativeTime}',
		description: 'action taken by the user on this object with relative timestamp - were mentioned',
		id: 'recommended.eventTypeMessage.relative.wereMentioned',
	},
	standalone: {
		defaultMessage: '{collaborator} were mentioned',
		description: 'action taken by the user on this object - were mentioned',
		id: 'recommended.eventTypeMessage.wereMentioned',
	},
});

export const messages = defineMessages({
	you: {
		id: 'recommended.you',
		defaultMessage: 'You',
		description:
			'Label to indicate the user themselves in event messages, e.g. "You commented on this page."',
	},
	collaborator: {
		id: 'recommended.collaborator',
		defaultMessage: 'Collaborator',
		description:
			'Label to indicate a collaborator in event messages, e.g. "Collaborator commented on this page."',
	},
});
